import DisplayData from 'portaltransparencia-common/components/displaydata/DisplayData.react.js';
import DisplayDataItem from 'portaltransparencia-common/components/displaydata/DisplayDataItem.react.js';
import DisplayDataRow from 'portaltransparencia-common/components/displaydata/DisplayDataRow.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import NumberUtils from 'portaltransparencia-common/libs/NumberUtils';
import { List } from 'immutable';
import { TipoEmendaParlamentar } from '../TipoEmendaParlamentar';
import { TITLE } from './FormDetail.react';

function AutoresVereadores({ autores }) {
  return (
    <>
      <h3 className="mb-xs">
        <b className="module-color">Vereadores</b>
      </h3>
      <DisplayData border>
        {autores.size > 0 ? (
          autores.map((vereador, index) => (
            <DisplayDataRow key={index}>
              <DisplayDataItem
                sm={12}
                title="Vereador"
                value={vereador.get('nome')}
                id={`vereador-${index}`}
              />
            </DisplayDataRow>
          ))
        ) : (
          <DisplayDataRow>
            <DisplayDataItem
              sm={12}
              value="Nenhum Vereador informado."
              id="vereador-empty"
            />
          </DisplayDataRow>
        )}
      </DisplayData>
    </>
  );
}

AutoresVereadores.propTypes = {
  autores: PropTypes.instanceOf(List).isRequired
};

function AutoresParlamentares({ autores }) {
  return (
    <>
      <h3 className="mb-xs">
        <b className="module-color">Autores</b>
      </h3>
      <DisplayData border>
        {autores.size > 0 ? (
          autores.map((parlamentar, index) => (
            <DisplayDataRow key={index}>
              <DisplayDataItem
                sm={6}
                title="Autor"
                value={parlamentar.get('nome')}
                id={`autor-${index}`}
              />
              <DisplayDataItem
                sm={6}
                title="Partido"
                value={parlamentar.get('partido')}
                id={`partido-${index}`}
              />
            </DisplayDataRow>
          ))
        ) : (
          <DisplayDataRow>
            <DisplayDataItem
              sm={12}
              value="Nenhum Parlamentar informado."
              id="parlamentar-empty"
            />
          </DisplayDataRow>
        )}
      </DisplayData>
    </>
  );
}

AutoresParlamentares.propTypes = {
  autores: PropTypes.instanceOf(List).isRequired
};

export default function FormDetailHeader({ emenda, tipo, isIntegradoOxy }) {
  const autores = emenda.get('autores', List());
  const isEmendaMunicipal = tipo === TipoEmendaParlamentar.MUNICIPAL;

  return (
    <>
      <h3 className="mb-xs">
        <b className="module-color">{`Emenda ${TITLE[tipo]}`}</b>
      </h3>
      <DisplayData border>
        <DisplayDataRow>
          <DisplayDataItem
            sm={4}
            title="Número/Ano"
            value={emenda.get('numeroAno')}
            id="numeroAno"
          />
          <DisplayDataItem
            sm={4}
            title="Plano de Ação"
            value={emenda.get('planoAcao')}
            id="planoAcao"
          />
          <DisplayDataItem
            sm={4}
            title="Forma de Repasse"
            value={emenda.get('tipoTransferencia')}
            id="tipoTransferencia"
          />
          <DisplayDataItem
            sm={4}
            title="Tipo de Transferência"
            value={emenda.get('origem')}
            id="origem"
          />
          {isIntegradoOxy &&
            (() => {
              const leiAto = emenda.getIn(['informacaoAdicional', 'leiAto']);
              return (
                <DisplayDataItem
                  sm={4}
                  title="Lei/Ato"
                  value={
                    leiAto
                      ? (() => {
                          const numero = leiAto.get('numero') ?? '';
                          const exercicio = leiAto.get('exercicio') ?? '';
                          const escopo =
                            leiAto.getIn(['escopo', 'descricao']) ?? '';
                          const parts = [];
                          if (numero || exercicio)
                            parts.push(`${numero}/${exercicio}`);
                          if (escopo) parts.push(escopo);
                          return parts.join(' ');
                        })()
                      : ''
                  }
                  id="leiAto"
                />
              );
            })()}
        </DisplayDataRow>
        {!isEmendaMunicipal && (
          <DisplayDataRow>
            {!isIntegradoOxy && (
              <DisplayDataItem
                sm={6}
                title="Localidade Beneficiada"
                value={emenda.get('localidadeBeneficiada')}
                id="localidadeBeneficiada"
              />
            )}
            <DisplayDataItem
              sm={6}
              title="Esfera de Governo"
              value={emenda.get('esfera')}
              id="esfera"
            />
          </DisplayDataRow>
        )}
        <DisplayDataRow>
          <DisplayDataItem
            sm={12}
            title="Objeto/Finalidade"
            value={emenda.get('objetoFinalidade')}
            id="objetoFinalidade"
          />
        </DisplayDataRow>
      </DisplayData>

      <hr className="mt-xs mb-xs" />

      <h3 className="mb-xs">
        <b className="module-color">Valores</b>
      </h3>

      <DisplayData border>
        <DisplayDataRow>
          <DisplayDataItem
            sm={6}
            title="Valor Previsto"
            value={NumberUtils.format(emenda.get('valorPrevisto'), 'R$ 0,0.00')}
            id="valorPrevisto"
          />
          <DisplayDataItem
            sm={6}
            title="Valor Repassado"
            value={NumberUtils.format(
              emenda.get('valorRepassado'),
              'R$ 0,0.00'
            )}
            id="valorRepassado"
          />
        </DisplayDataRow>
      </DisplayData>

      <hr className="mt-xs mb-xs" />

      {isEmendaMunicipal ? (
        <AutoresVereadores autores={autores} />
      ) : (
        <AutoresParlamentares autores={autores} />
      )}
    </>
  );
}

FormDetailHeader.propTypes = {
  emenda: PropTypes.object.isRequired,
  tipo: PropTypes.oneOf(Object.values(TipoEmendaParlamentar)).isRequired,
  isIntegradoOxy: PropTypes.bool
};
